var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeavyDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0052cb",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "298.677,194.193 325.54,254.786 344.228,246.5 316.797,184.624 346.444,199.344 355.529,181.035 290.508,148.745 269.843,220.339 289.49,226.01  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.11,309.948l-8.226-18.718l-195.306,85.874c-12.032-12.181-28.729-19.746-47.167-19.746 c-3.869,0-7.655,0.352-11.344,0.991L82.988,25.557L17.298,0L9.89,19.058L67.354,41.41L198.673,364.94 c-21.129,11.102-35.581,33.257-35.581,58.737c0,36.569,29.751,66.323,66.318,66.323c36.579,0,66.329-29.754,66.329-66.323 c0-10.629-2.528-20.674-6.992-29.588L480.11,309.948z M229.411,469.554c-25.297,0-45.873-20.581-45.873-45.878 c0-25.292,20.576-45.873,45.873-45.873c25.297,0,45.883,20.581,45.883,45.873C275.293,448.974,254.708,469.554,229.411,469.554z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.495,317.466c9.14,20.605,31.748,18.109,37.258,14.701l137.258-59.56c14.326-6.21,20.925-22.922,14.716-37.252 L378.221,93.588c-4.992-11.521-19.218-17.181-30.808-12.169l-141.781,61.51c-14.316,6.215-20.906,22.927-14.695,37.253 L250.495,317.466z M213.777,161.688l141.782-61.511c1.863-0.721,3.338,0.256,3.903,1.543l61.507,141.767 c1.727,3.988-0.099,8.635-4.093,10.362l-137.258,59.56c-3.954,1.688-8.686-0.225-10.373-4.083l-59.55-137.273 C207.967,168.062,209.794,163.415,213.777,161.688z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavyDelivery);
export default __webpack_public_path__ + "static/media/heavy-delivery.863bc5e93a5931ce0b38c2b5c37fb294.svg";
export { ForwardRef as ReactComponent };